import { TrackGoodIcon } from 'src/assets/icons'
import { useStyles } from './styles'

const RedirectPageWrapper = () => {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      <TrackGoodIcon className={classes.icon} />
    </div>
  )
}

export { RedirectPageWrapper }
